import { useState, useRef, useEffect } from "react";
import { FieldError } from "react-hook-form";
import { FaChevronDown } from "react-icons/fa";

interface FormSelectProps {
  label?: string;
  placeholder: string;
  value: string;
  onChange: (v: string) => void;
  options: string[];
  error?: FieldError;
}

const FormSelect = ({
  label,
  placeholder,
  value,
  onChange,
  options,
  error,
}: FormSelectProps) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="flex flex-col gap-1.5" ref={ref}>
      {label && <label className="text-sm text-[#4A4A4A]">{label}</label>}
      <div
        className={`relative w-full h-12 px-4 rounded-lg border bg-[#FAFAFA] flex items-center justify-between cursor-pointer select-none ${
          error ? "border-red-400" : "border-[#E0E0E0]"
        }`}
        onClick={() => setOpen((p) => !p)}
      >
        <span className={`text-sm ${value ? "text-dark-100" : "text-[#BDBDBD]"}`}>
          {value || placeholder}
        </span>
        <FaChevronDown
          className={`text-[11px] text-[#9E9E9E] transition-transform ${open ? "rotate-180" : ""}`}
        />
        {open && (
          <div className="absolute top-full left-0 mt-1 w-full bg-white rounded-lg border border-[#E0E0E0] shadow-lg z-10 max-h-52 overflow-y-auto">
            {options.map((opt) => (
              <div
                key={opt}
                className={`px-4 py-3 text-sm cursor-pointer hover:bg-[#FFF8E7] transition-colors ${
                  value === opt ? "text-[#CBA135] font-semibold" : "text-dark-100"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange(opt);
                  setOpen(false);
                }}
              >
                {opt}
              </div>
            ))}
          </div>
        )}
      </div>
      {error && <p className="text-xs text-red-500">{error.message}</p>}
    </div>
  );
};

export default FormSelect;
